import { IDynamicTableParams } from 'components/DynamicTable';
import instance from 'api';

// Журнал изменений настроек геоконтроля. Отдельного эндпоинта на бэке нет —
// это общий реестр /auditLog, жёстко отфильтрованный по контексту «Геоконтроль»
// (Contexts.CHRONA_GEO_ZONE), под которым пишут ChronaGeoZoneService и ChronaAssignmentService.
export const getAuditLog = (filters: IDynamicTableParams) =>
  instance()
    .post('auditLog/list', filters)
    .then((response) => response.data);

export const getAvailableColumns = () =>
  instance()
    .post('auditLog/availableColumns')
    .then((response) => response.data);

export const getFilterColumns = () =>
  instance()
    .post('auditLog/availableGroupColumns')
    .then((response) => response.data);
